



















import { Component, Vue } from 'vue-property-decorator'
import { locales } from '../i18n'

@Component({
  components: {}
})
export default class LanguageSwitcher extends Vue {
  get locales () {
    return locales
  }

  setLocale (locale: Record<string, string>) {
    this.$i18n.locale = locale.code
    this.$q.cookies.set('locale', locale.code, {
      expires: new Date(new Date().getTime() + 86400 * 365 * 1000).toJSON()
    })
    import(`quasar/lang/${locale.iso}`).then(language => {
      (this.$q as any).lang.set(language.default)
    })
  }
}
